import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _class, _AbProgress;
/*
 *                     NOTICE
 *            COPYRIGHT 2021 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { BaseRCmp } from "abreact/incubator/ui/component/BaseRCmp";
import { AbProgressIndicator } from "abreact/progress/AbProgressIndicator";
import { BlockingProgressAction, BlockingProgressActionPopupHandle } from "abreact/progress/manager/BlockingProgressAction";
import { ArrayUtils } from "abweb/utils/ArrayUtils";
import { observer } from "mobx-react";
import * as React from "react";
/**
 *  Class for dealing with progress dialogs and bars in managed and also un-managed way.
 *  Also see abreact/incubator/ui/component/Feedback
 */
export let AbProgress = observer(_class = (_AbProgress = class AbProgress extends BaseRCmp {
  /**
   * Shows a modal popup with the specified message.
   *
   * @param message The message to be shown to the user.
   * @returns The popup handle of the popup that will be shown.
   */
  static show(message) {
    return AbProgress.showAfterDelay(message, 0);
  }

  /**
   * Shows a modal popup with the specified message after an initial delay.
   *
   * Note: it is safe to close the popup via the handle before the delay time has elapsed.
   * In this situation, the popup will just not be shown.
   *
   * @param message The message to be shown to the user.
   * @param initialDelay An optional delay in milliseconds to wait before showing the popup (defaults to 750ms).
   * @param onCancel Callback made when the cancel button is hit. Shows a cancel button if non-null.
   * @returns The popup handle of the popup that will be shown.
   */
  static showAfterDelay(message, initialDelay, onCancel) {
    let blockingProgressAction = new BlockingProgressAction({
      name: "AbProgress:showAfterDelay",
      title: message,
      initialDelay,
      onCancel: onCancel
    });
    blockingProgressAction.show().then();
    // wrap the action in a thin AbPopupHandle class, to allow clients to "close" the action.
    return new BlockingProgressActionPopupHandle(blockingProgressAction);
  }

  /**
   * Show a modal popup for a promise, closing when it has been resolved or rejected.
   *
   * @param promise The promise to show progress for.
   * @param message The message to be shown to the user while the action is in process
   * @param initialDelay The initial delay before the modal is shown (defaults to 750ms).
   * @param onCancel Callback made when the cancel button is hit. Shows a cancel button if non-null.
   * @returns A promise representing the lifetime of the modal.
   */
  static showUntilPromiseCompletes(promise, message, initialDelay, onCancel) {
    return new Promise(function (resolve, reject) {
      let popupHandle = AbProgress.showAfterDelay(message, initialDelay, onCancel);
      promise.then(value => {
        popupHandle.close();
        resolve(value);
      }).catch(reason => {
        popupHandle.close();
        reject(reason);
      });
    });
  }
  render() {
    return /*#__PURE__*/React.createElement(AbProgressIndicator, this.props);
  }
}, _defineProperty(_AbProgress, "renderProgressContent", content => {
  if (ArrayUtils.isStringArray(content)) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, content.map((s, index) => /*#__PURE__*/React.createElement("div", {
      key: index
    }, s)));
  }
  return content;
}), _AbProgress)) || _class;
//# sourceMappingURL=AbProgress.js.map
